function toggleWishlistHeart(btn) {
  if (typeof window._swat === 'undefined') return;

  var productId = parseInt(btn.dataset.wishlistProductId);
  var variantId = parseInt(btn.dataset.wishlistVariantId);
  var productUrl = btn.dataset.wishlistProductUrl;

  var product = {
    epi: variantId,
    empi: productId,
    du: productUrl
  };

  if (btn.classList.contains('is-wishlisted')) {
    window._swat.removeFromWishList(product, function() {
      btn.classList.remove('is-wishlisted');
      btn.setAttribute('aria-label', 'Add to wishlist');
    });
  } else {
    window._swat.addToWishList(product, function() {
      btn.classList.add('is-wishlisted');
      btn.setAttribute('aria-label', 'Remove from wishlist');
    });
  }
}

/* Check initial wishlist state once Swym loads */
(function checkWishlistState() {
  if (typeof window._swat === 'undefined') {
    setTimeout(checkWishlistState, 500);
    return;
  }
  window._swat.fetch(function(products) {
    document.querySelectorAll('.wishlist-heart-overlay').forEach(function(btn) {
      var productId = parseInt(btn.dataset.wishlistProductId);
      var variantId = parseInt(btn.dataset.wishlistVariantId);
      var isWishlisted = products.some(function(p) {
        return p.epi === variantId || p.empi === productId;
      });
      if (isWishlisted) {
        btn.classList.add('is-wishlisted');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      }
    });
  });
})();
